import React, {Component} from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import Card from '../../Components/Card/Index.js'
import CardMeeting from '../../Components/Card/MeetingCard.js'

import Popup from '../../Components/Popup/Index.js'
import Sidebar from '../../Components/Sidebar/Index.js'
import Navbar from '../../Components/Navbar/Index.js'
import ProfileTrigger from '../../Components/ProfileTrigger/Index.js'
import Loader from '../../Components/Loader/Index.js'
import LoaderInline from '../../Components/Loader/LoaderInline.js'
import { AddIcon } from '../../Svg/Index.js'
import { FETCH_WAZZUP, LOAD_MORE_WAZZUP } from '../../Actions/Wazzup'
import { GET_CURRENT_USER } from '../../Actions/User'
import { SET_TYPE, SET_LIKES_POPUP_ACTIVE } from '../../Actions/Sidebar'
import { MERCURE_URL } from '../../config'
import LikesPopup from '../../Components/Popup/LikesPopup.js'
import WazzupFilter from '../../Components/Navbar/WazzupFilter.js'


class Wazzup extends Component {

    state = {
        sharePopupActive: false,
        feedLoading: false,
        page: 1,
        isPaginating: false,
        likesPopupActive: false,
        fetchedAllThreads: false,
    }

    UNSAFE_componentWillMount() {
        const { user } = this.props;

        // this.props.actions.GET_CURRENT_USER(this.props.user)

        if(!user.token) {
            this.props.history.push('/')
        }
        this.props.actions.FETCH_WAZZUP(this.props.wazzup_type === 'friends').then(()=> {
            this.setState({
                feedLoading: false
            })
        })
    }

    UNSAFE_componentWillReceiveProps(nextProps) {

        if(this.props.wazzup_type !== nextProps.wazzup_type) {
            
            this.setState({ fetchedAllThreads: false, page: 1 }, () => {
                this.props.actions.FETCH_WAZZUP(nextProps.wazzup_type === 'friends')
            })
        }

    }


    componentDidMount() {
        const { wazzup } = this.props;

        if(!localStorage.getItem(`@JO:WebReturningUser-${JSON.parse(localStorage.getItem('@JO:user')).username}`)) {
            localStorage.setItem(`@JO:WebReturningUser-${JSON.parse(localStorage.getItem('@JO:user')).username}`, true)
            this.props.actions.SET_TYPE('edit_profile');
        }

        document.querySelectorAll('.o-web-container')[0].addEventListener('scroll', this.loadMoreWazzup);
       

        if(!wazzup.threads.length) {
            this.setState({
                feedLoading: true
            })
        }

        this.eventSource = new EventSource(`${MERCURE_URL}?topic=https://jongenout.nl/wazzup/new`);
		this.eventSource.addEventListener('message', () => {
            this.props.actions.FETCH_WAZZUP(this.props.wazzup_type === 'friends')
        })
        document.body.classList.add('has-background');
    }

    componentWillUnmount() {
        document.body.classList.remove('has-background');
        document.querySelectorAll('.o-web-container')[0].removeEventListener('scroll', this.loadMoreWazzup);
        if(this.eventSource) {
            this.eventSource.close();
        }
    }

    loadMoreWazzup = () => {
        if(this.state.fetchedAllThreads) return;

        let element = document.querySelectorAll('.o-web-container')[0];
        if(this.props.wazzup.pagination.pagination_has_next_page && (element.scrollHeight - element.scrollTop < element.clientHeight + 800) ) {
            if(!this.state.isPaginating) {
                this.setState({ isPaginating: true, page: this.state.page+1 })
                this.props.actions.LOAD_MORE_WAZZUP(this.state.page, this.props.wazzup_type === 'friends').then((req)=> {
                    this.setState({ isPaginating: false, fetchedAllThreads: !!!req.threads.length })
                });
            }
        }
    }


    openSharePopup = () => {
        this.setState({
            sharePopupActive: true
        });
        document.body.classList.add('is-blurred');

    }

    closeSharePopup = () => {
        this.setState({
            sharePopupActive: false
        });
        document.body.classList.remove('is-blurred');

    }

    closeLikesPopup = () => {
        this.setState({
            likesPopupActive: false
        });
        this.props.actions.SET_LIKES_POPUP_ACTIVE(false)
        document.body.classList.remove('is-blurred');

    }
    

    render() {
        const { user, wazzup } = this.props;
        const { sharePopupActive, feedLoading } = this.state;

        return (
            <>
                <div className="o-page-wrap">

                    <Sidebar />
                    <Navbar />
                    <ProfileTrigger />


                    <WazzupFilter />


                    <div className="o-main-container">
                        <div className={`js-fade-content ${sharePopupActive ? 'is-active' : ''} ${this.props.sidebar.likes_popup_active ? 'is-active' : ''}`}>
                            <h1>Wazzup</h1>
                            {
                                feedLoading && (
                                    <div className="c-general-loader">
                                        <Loader />
                                    </div>
                                )
                            }
                            

                            <div className="c-feed">
                                {
                                    wazzup.threads.map((item, i) => {
                                        if(!!item.meeting) {
                                            return (
                                                <CardMeeting 
                                                    key={`meeting-wall-${i}`}
                                                    users={item.meeting.user_count}
                                                    date={item.meeting.date_for_humans}
                                                    end_time={item.meeting.endTime}
                                                    id={item.meeting._id}
                                                    title={item.meeting.title}
                                                    intro={item.meeting.intro}
                                                    content={item.meeting.content}
                                                    image={item.meeting.image}
                                                    address={item.meeting.address}
                                                />
                                            )
                                        }

                                        return (
                                            <Card 
                                                key={`wazzup-wall-${i}`}
                                                user={item.first_message.user}
                                                author={item.first_message.user.display_name}
                                                authorImage={item.first_message.user.avatar.user_avatar}
                                                createdAt={item.first_message.created_at_for_humans}
                                                body={item.first_message.body}
                                                image={item.first_message.image}
                                                messageCount={item.message_count}
                                                uuid={item._uuid}
                                                id={item._id}
                                                type="wazzup"
                                                pinned={item.is_pinned}
                                                like_count={item.like_count}
                                                showLikes={true}
                                                item={item}
                                                afterDelete={() => {
                                                    this.props.actions.FETCH_WAZZUP(this.props.wazzup_type === 'friends')
                                                }}
                                            />
                                        )
                                    }
                                        
                                    )
                                }

                                <div className="o-main-container__center">
                                    <button className="c-btn c-btn--primary c-btn--compact c-btn--bottom-float js-share-button" onClick={this.openSharePopup}>
                                        <span className="c-btn__icon"><AddIcon /></span>Deel iets met de community
                                    </button>
                                </div>

                                {
                                    this.state.isPaginating && (
                                        <LoaderInline />
                                    )
                                }

                            </div>
                        </div>
                        {
                            sharePopupActive && (
                                <Popup closeSharePopup={this.closeSharePopup.bind(this)} author={user.avatar.user_avatar} />
                            )
                        }

                        {
                            this.props.sidebar.likes_popup_active && (
                                <LikesPopup closeLikesPopup={this.closeLikesPopup.bind(this)} />
                            )
                        }

                    </div>
                </div>
            </>
        )
    }
}
const mapStateToProps = state => {
    return {
        wazzup_type: state.wazzup.wazzup_type,
        user: state.user.user,
        wazzup: state.wazzup,
        sidebar: state.sidebar,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        actions: bindActionCreators({FETCH_WAZZUP, SET_TYPE, LOAD_MORE_WAZZUP, GET_CURRENT_USER, SET_LIKES_POPUP_ACTIVE}, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Wazzup)